import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconFileText';
/** Renders an SVG icon. */
const SvgFileText = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M20 8h2.586L20 5.414zm6 19a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h10a1 1 0 0 1 .707.293l6 6A1 1 0 0 1 26 9zM8 27a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V10h-4.5A1.5 1.5 0 0 1 18 8.5V4H9a1 1 0 0 0-1 1z"
      />
      <path
        fill="currentColor"
        d="M15 22a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2zm6-4a1 1 0 1 1 0 2H11a1 1 0 1 1 0-2zm-2-4a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2z"
      />
    </svg>
  );
};
SvgFileText.displayName = displayName;
export default SvgFileText;
